let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aPj2s")).then(() => parcelRequire('5R8Ny'));